import { axios } from '@/utils/request'

// 查询Banner列表
export function getBannerList(params) {
  return axios({
    url: '/banners',
    method: 'get',
    params: params
  })
}


// 修改Banner/添加Banner
export function updateBanner(params) {
  return axios({
    url: `/banner/save`,
    method: 'post',
    data: params
  })
}

// 删除Banner
export function deleteBanner(banner_id) {
  return axios({
    url: `/banner/${banner_id}`,
    method: 'delete'
  })
}
